/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Create_Folder_PlaceholderInputs */

const en_explorer_nav_create_folder_placeholder = /** @type {(inputs: Explorer_Nav_Create_Folder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter folder name`)
};

const fr_explorer_nav_create_folder_placeholder = /** @type {(inputs: Explorer_Nav_Create_Folder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez le nom du dossier`)
};

const de_explorer_nav_create_folder_placeholder = /** @type {(inputs: Explorer_Nav_Create_Folder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordnernamen eingeben`)
};

const it_explorer_nav_create_folder_placeholder = /** @type {(inputs: Explorer_Nav_Create_Folder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci il nome della cartella`)
};

const ru_explorer_nav_create_folder_placeholder = /** @type {(inputs: Explorer_Nav_Create_Folder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите название папки`)
};

const es_explorer_nav_create_folder_placeholder = /** @type {(inputs: Explorer_Nav_Create_Folder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduzca el nombre de la carpeta`)
};

const zh_cn2_explorer_nav_create_folder_placeholder = /** @type {(inputs: Explorer_Nav_Create_Folder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入文件夹名称`)
};

const ja_explorer_nav_create_folder_placeholder = /** @type {(inputs: Explorer_Nav_Create_Folder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダ名を入力`)
};

const hi_explorer_nav_create_folder_placeholder = /** @type {(inputs: Explorer_Nav_Create_Folder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ोल्डर का नाम दर्ज करें`)
};

const pt_pt2_explorer_nav_create_folder_placeholder = /** @type {(inputs: Explorer_Nav_Create_Folder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite o nome da pasta`)
};

/**
* | output |
* | --- |
* | "Enter folder name" |
*
* @param {Explorer_Nav_Create_Folder_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_create_folder_placeholder = /** @type {((inputs?: Explorer_Nav_Create_Folder_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Create_Folder_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_nav_create_folder_placeholder(inputs)
	if (locale === "de") return de_explorer_nav_create_folder_placeholder(inputs)
	if (locale === "it") return it_explorer_nav_create_folder_placeholder(inputs)
	if (locale === "ru") return ru_explorer_nav_create_folder_placeholder(inputs)
	if (locale === "es") return es_explorer_nav_create_folder_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_nav_create_folder_placeholder(inputs)
	if (locale === "ja") return ja_explorer_nav_create_folder_placeholder(inputs)
	if (locale === "hi") return hi_explorer_nav_create_folder_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_nav_create_folder_placeholder(inputs)
	return en_explorer_nav_create_folder_placeholder(inputs)
});